import React, { FC, memo } from 'react';

import { TEXTS } from 'application/pages/texts';

import { SelectedPoint } from '../../types';

interface ModalTitleProps {
  selectedPoints: SelectedPoint[];
  isAtLeastOnePointWithoutDevice: boolean;
}

const ModalTitle: FC<ModalTitleProps> = ({ selectedPoints, isAtLeastOnePointWithoutDevice }) => {
  if (selectedPoints.length > 1) {
    return isAtLeastOnePointWithoutDevice ? TEXTS.MODAL_BIND_SUCCESS_NON_ACTIVE_TITLE : TEXTS.MODAL_BIND_SUCCESS_TITLE;
  }

  const isPointEnabled = selectedPoints[0].isEnabled === true;

  const successBindTitle = isPointEnabled ? TEXTS.MODAL_BIND_SUCCESS_TITLE : TEXTS.MODAL_BIND_SUCCESS_NON_ACTIVE_TITLE;

  return <div>{successBindTitle}</div>;
};

export default memo(ModalTitle);
